import BlogCard from './BlogCard';

const BlogList = ({ posts = [], onOpen }) => {
  if (!posts.length) {
    return (
      <div className="text-center py-12">
        <p className="text-lg text-gray-600">No articles available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {posts.map((p) => (
        <BlogCard
          key={p.id || p.slug}
          title={p.title}
          excerpt={p.excerpt}
          date={p.date}
          category={p.category}
          onClick={() => onOpen(p)}
        />
      ))}
    </div>
  );
};

export default BlogList;
